"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPathToPageName = exports.buildCMSEventObj = exports.sendCMSEvent = exports.checkEventObj = exports.createEventObject = exports.createPageEventObject = exports.TAG_EVENT_TYPES = exports.ERROR_REQUIRED_KEYS = exports.REQUIRED_KEYS = void 0;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
const bit_utils_log_utils_1 = require("@gcloud-npm/bit.utils.log-utils");
const bit_utils_common_1 = require("@gcloud-npm/bit.utils.common");
const bit_utils_constants_1 = require("@gcloud-npm/bit.utils.constants");
const bit_utils_monitoring_1 = require("@gcloud-npm/bit.utils.monitoring");
exports.REQUIRED_KEYS = [
    'componentVariation',
    'componentContent',
    'componentProduct',
];
exports.ERROR_REQUIRED_KEYS = ['eventType', 'errorDetail', 'errorOrigin'];
exports.TAG_EVENT_TYPES = {
    CLICK: 'click',
    SCROLL: 'scroll',
};
var createPageEventObject = function (data) {
    if (!data) {
        return null;
    }
    var clientIDs = data.clientIDs, userTypeFromData = data.userType;
    var _a = data.event, event = _a === void 0 ? 'cms-page' : _a, _b = data.eventType, eventType = _b === void 0 ? '' : _b, _c = data.tabId, tabId = _c === void 0 ? '' : _c, _d = data.pageName, pageName = _d === void 0 ? '' : _d, _e = data.pageProductCode, pageProductCode = _e === void 0 ? '' : _e, _f = data.pageProductName, pageProductName = _f === void 0 ? '' : _f, _g = data.contextGaCookie, contextGaCookie = _g === void 0 ? (clientIDs && clientIDs.ga) || null : _g, _h = data.contextSessionId, contextSessionId = _h === void 0 ? (clientIDs && clientIDs.sessId) || null : _h, _j = data.contextPageId, contextPageId = _j === void 0 ? (clientIDs && clientIDs.pageId) || null : _j, _k = data.userCUCFijoHash, userCUCFijoHash = _k === void 0 ? '' : _k, _l = data.userCUCMovilHash, userCUCMovilHash = _l === void 0 ? '' : _l, _m = data.userCUCPrepagoHash, userCUCPrepagoHash = _m === void 0 ? '' : _m, _o = data.userIPHash, userIPHash = _o === void 0 ? '' : _o, _p = data.userOperadorHash, userOperadorHash = _p === void 0 ? '' : _p, _q = data.userTelefonoFijoHash, userTelefonoFijoHash = _q === void 0 ? '' : _q, _r = data.userTelefonoMovilHash, userTelefonoMovilHash = _r === void 0 ? '' : _r, _s = data.userIdPartyHash, userIdPartyHash = _s === void 0 ? '' : _s, _t = data.userType, userType = _t === void 0 ? '' : _t, _u = data.userConsentCookieOneTrust, userConsentCookieOneTrust = _u === void 0 ? '' : _u, _v = data.pageSegment, pageSegment = _v === void 0 ? '' : _v, _w = data.contextURL, contextURL = _w === void 0 ? '' : _w, _x = data.testVersion, testVersion = _x === void 0 ? '' : _x, _y = data.testName, testName = _y === void 0 ? '' : _y, _z = data.userClient, userClient = _z === void 0 ? !!userTypeFromData : _z, _0 = data.userPriority, userPriority = _0 === void 0 ? '' : _0, _1 = data.contextSeoMeta, contextSeoMeta = _1 === void 0 ? '' : _1, _2 = data.userGl, userGl = _2 === void 0 ? '' : _2;
    return {
        event: event,
        'event-type': eventType,
        'context-tab-id': tabId,
        'page-name': pageName,
        'page-product-code': pageProductCode,
        'page-product-name': pageProductName,
        // client id de ga
        'context-ga-cookie': contextGaCookie,
        // id de sesión de la navegación del usuario
        'context-session-id': contextSessionId,
        // page id de la página
        'context-page-id': contextPageId,
        'user-cuc-fijo-hash': userCUCFijoHash,
        'user-cuc-movil-hash': userCUCMovilHash,
        'user-cuc-prepago-hash': userCUCPrepagoHash,
        'user-gl': userGl,
        'user-ip-hash': userIPHash,
        'user-operador-hash': userOperadorHash,
        'user-telefono-fijo-hash': userTelefonoFijoHash,
        'user-telefono-movil-hash': userTelefonoMovilHash,
        'user-id-party-hash': userIdPartyHash,
        // telco o legado
        'user-type': userType,
        // estado consentimientos cookies del usuario
        'user-consent-cookie-onetrust': userConsentCookieOneTrust,
        // segmento de navegación de la página
        'page-segment': pageSegment,
        // url de la página
        'context-url': contextURL,
        'test-version': testVersion,
        'test-name': testName,
        // true o false si es cliente o no
        'user-client': userClient,
        // true o false si es priority o no
        'user-priority': userPriority,
        // meta description de seo
        'context-seo-meta': contextSeoMeta,
    };
};
exports.createPageEventObject = createPageEventObject;
/**
 * Crea el objeto con la estructura adecuada para un evento de componente de métricas
 * @param {String} eventType
 * @param {String} componentName
 * @param {String} componentVariation
 * @param {String} componentContent
 * @param {String} componentProduct
 * @param {Object} componentPerso
 * @param {String} event
 */
var createEventObject = function (inputObj, eventType) {
    if (eventType === void 0) {
        eventType = exports.TAG_EVENT_TYPES.CLICK;
    }
    var finalRes = {
        event: 'cms-component',
        'event-type': eventType,
        'component-name': '',
        'component-variation': '',
        'component-content': '',
        'component-product': '',
        'component-perso': {},
    };
    var keys = inputObj ? Object.keys(inputObj) : [];
    keys.forEach(function (key) {
        var resKey = (0, bit_utils_common_1.toKebabCase)(key);
        var resValue = inputObj[key];
        if (typeof resValue === 'string') {
            resValue = (0, bit_utils_common_1.normalizeString)(resValue);
        }
        finalRes[resKey] = resValue;
        finalRes[resKey] = finalRes[resKey] || '';
    });
    return finalRes;
};
exports.createEventObject = createEventObject;
var checkEventObj = function (taggingInfo) {
    var res = true;
    exports.REQUIRED_KEYS.forEach(function (key) {
        if (typeof taggingInfo[key] === 'undefined') {
            res = false;
        }
    });
    if (taggingInfo.debug) {
        res = true;
    }
    return res;
};
exports.checkEventObj = checkEventObj;
/**
 * Envía a la cola adecuada de métricas un evento de componente.
 * @param {*} eventType
 * @param {*} componentName
 * @param {*} componentVariation
 * @param {*} componentContent
 * @param {*} componentProduct
 * @param {*} componentPerso
 */
var sendCMSEvent = function (inputObj) {
    var checkObj = (0, exports.checkEventObj)(inputObj);
    var object = (0, exports.createEventObject)(inputObj);
    try {
        if (checkObj) {
            window.nookInfoExchange.sendMessage('Metrics', object);
        }
        else {
            (0, bit_utils_log_utils_1.errorLog)('TaggingInfo is no properly defined', '[checkEventObj] no right event structure');
        }
    }
    catch (err) {
        // TODO monirorizar donde toque.
    }
};
exports.sendCMSEvent = sendCMSEvent;
var buildCMSEventObj = function (kind, status, eventFamily, id, customizerId, taggingInfo) {
    if (kind === void 0) {
        kind = 'print';
    }
    if (eventFamily === void 0) {
        eventFamily = 'cms-component';
    }
    var componentUuid = (0, bit_utils_monitoring_1.getUUID)();
    var newEvent = "".concat(kind, "-").concat(status);
    var event = __assign(__assign({}, taggingInfo), { event: eventFamily, eventType: newEvent, componentUuid: componentUuid });
    if (id) {
        event.componentName = id;
    }
    event.customizerId = customizerId;
    if (status === bit_utils_constants_1.NETWORK_STATUS.FETCHING) {
        event.componentUuid = componentUuid;
    }
    // set necesary props to avoid checkEventObj
    if (!event.componentName) {
        event.componentName = '';
    }
    if (!event.componentVariation) {
        event.componentVariation = '';
    }
    if (!event.componentContent) {
        event.componentContent = '';
    }
    if (!event.componentProduct) {
        event.componentProduct = '';
    }
    return event;
};
exports.buildCMSEventObj = buildCMSEventObj;
/**
 * Funcion que recibe una cadena y la normaliza, reemplazando las / por :
 * @param {string} unnormalizedString cadena sin normalizar
 * @return {string} normalizedString cadena normalizada
 */
var replaceSlashToColon = function (unnormalizedString) {
    var normalizedString = unnormalizedString.replace(/\//g, ':');
    return normalizedString;
};
/**
 * Funcion que normaliza y retorna el pathname actual
 * @return {string} normalizedUrl pathname normalizado
 */
var convertPathToPageName = function () {
    var normalizedUrl = '';
    if (window && window.location) {
        var pathname = window.location.pathname;
        var pathNameWithoutFirstSlash = pathname.replace('/', '');
        normalizedUrl = replaceSlashToColon(pathNameWithoutFirstSlash).toLowerCase();
    }
    return normalizedUrl;
};
exports.convertPathToPageName = convertPathToPageName;
//# sourceMappingURL=index.js.map